<div class="flex gap-6 h-[calc(90vh-theme(spacing.20))]">
  <!-- Left side - Category tree -->
  <div class="w-1/3 flex flex-col gap-4 h-full">
    <cac-button class="w-full flex-shrink-0" [disabled]="selectedCategory() === undefined" (onClick)="onNewCategory()">
      New Category
    </cac-button>
    <app-category-tree
      [categories]="categories$"
      class="flex-1 min-h-0"
      [control]="categoryIdControl"
      [showPosition]="true"
      [isSearchable]="true"
    />
  </div>
  
  <!-- Right side - Category details -->
  <div
    class="category-details flex-auto h-full flex flex-col border border-outline rounded-3 overflow-hidden {{
      isLoadingCategory() ? 'opacity-50 pointer-events-none' : ''
    }}"
  >
    <!-- Scrollable content area -->
    <div class="flex-1 overflow-y-auto overflow-x-hidden p-8 min-h-0">
      <!-- Image uploader section - fixed height -->
      <div class="flex gap-2 flex-shrink-0">
        <cac-image-uploader [control]="form.controls.imagePath" label="Image" class="h-36 w-36" />
      </div>

      <!-- Form fields section -->
      <div class="flex flex-col pt-4">
        <!-- Top form fields - fixed height -->
        <div class="grid grid-cols-2 gap-x-6 gap-y-2 w-full flex-shrink-0">
          <cac-field autoComplete="false" [control]="form.controls.englishName" label="English Name"></cac-field>
          <cac-field autoComplete="false" [control]="form.controls.arabicName" label="Arabic Name"></cac-field>
          <cac-field autoComplete="false" [control]="form.controls.priority" label="Position" type="number"></cac-field>
          <cac-switch [control]="form.controls.status" label="Enabled"></cac-switch>
        </div>

        <!-- Parent Category section - constrained height with internal scrolling -->
        <div class="flex flex-col mt-4 min-h-0">
          <h3 class="text-lg font-medium mb-4 flex-shrink-0">Parent Category</h3>
          <div class="border border-outline rounded-2 max-h-80 overflow-y-auto">
            <app-category-tree
              [categories]="categories$"
              [control]="form.controls.parentCategoryId"
              [hideClear]="false"
              [isSearchable]="true"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Action buttons - fixed at bottom -->
    <div class="border-t border-outline p-4 flex-shrink-0 flex justify-end gap-4">
      @if (selectedCategory() !== undefined && !isRestrictedAdmin) {
        <cac-button (onClick)="onDelete()" theme="error" appearance="stroked" class="w-32">
          Delete
        </cac-button>
      }
      <cac-button (onClick)="onSubmit($event)" class="w-32">
        {{ selectedCategory() === undefined ? 'Add' : 'Update' }}
      </cac-button>
    </div>
  </div>
</div>
